import dayjs from "dayjs";

export function maskCPF(cpf: string | undefined): string {
  if (!cpf) return "-";

  let value = cpf.replace(/\D/g, "");
  value = value.slice(0, 11);

  if (value.length > 9) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  } else if (value.length > 6) {
    return value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1.$2.$3");
  } else if (value.length > 3) {
    return value.replace(/(\d{3})(\d{0,3})/, "$1.$2");
  }

  return value;
}

export function maskCNPJ(value: string): string {
  const numericValue = value.replace(/\D/g, "").slice(0, 14);
  value = numericValue.replace(/(\d{2})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1/$2");
  value = value.replace(/(\d{4})(\d{2})$/, "$1-$2");

  return value;
}

export function maskCEP(value: string): string {
  const numericValue = value.replace(/\D/g, "").slice(0, 8);
  value = numericValue.replace(/(\d{5})(\d)/, "$1-$2");

  return value;
}

export function maskZipCode(value: string): string {
  const numericValue = value.replace(/\D/g, "").slice(0, 9);

  if (numericValue.length > 5) {
    return numericValue.replace(/(\d{5})(\d{0,4})/, "$1-$2");
  }

  return numericValue;
}

export function maskSSN(value: string): string {
  const numericValue = value.replace(/\D/g, "").slice(0, 9);
  value = numericValue.replace(/(\d{3})(\d)/, "$1-$2");
  return value;
}

export function maskPhone(value: string): string {
  value = value.replace(/\D/g, "");
  value = value.slice(0, 11);
  if (value.length > 10) {
    value = value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (value.length > 6) {
    value = value.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  } else if (value.length > 2) {
    value = value.replace(/(\d{2})(\d{0,5})/, "($1) $2");
  }

  return value;
}

export function maskUSPhone(value: string): string {
  value = value.replace(/\D/g, "");
  value = value.slice(0, 10);
  if (value.length > 6) {
    value = value.replace(/(\d{3})(\d{3})(\d{0,4})/, "($1) $2-$3");
  } else if (value.length > 3) {
    value = value.replace(/(\d{3})(\d{0,3})/, "($1) $2");
  } else if (value.length > 0) {
    value = value.replace(/(\d{0,3})/, "($1");
  }

  return value;
}

export function maskReal(value: string | number): string {
  if (!value) {
    return "R$ 0,00";
  }

  let numericValue: number;

  if (typeof value === "string") {
    numericValue = Number(value.replace(/\D/g, "")) / 100;
  } else {
    numericValue = value / 100;
  }

  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(numericValue);
}

export function maskDollar(value: string | number): string {
  if (!value) {
    return "$0.00";
  }

  let numericValue: number;

  if (typeof value === "string") {
    numericValue = Number(value.replace(/\D/g, "")) / 100;
  } else {
    numericValue = value / 100;
  }

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(numericValue);
}

export function maskBirthdate(value: string) {
  return dayjs().diff(dayjs(value), "years") + " years";
}

export function maskDate(value: string) {
  return dayjs(value).format("MM/DD/YYYY");
}

export function maskDateWithTime(value: string) {
  return dayjs(value).format("MM/DD/YYYY [at] HH:mm");
}
